import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    translation: {
      // Navigation
      home: 'Ana Sayfa',
      lessons: 'Dersler',
      instructors: 'Eğitmenler',
      aiProgram: 'AI Program',
      myProfile: 'Profilim',
      login: 'Giriş Yap',
      register: 'Kayıt Ol',
      logout: 'Çıkış',
      
      // Auth
      loginTitle: 'Hesabınıza Giriş Yapın',
      loginDescription: 'E-posta ve şifreniz ile giriş yapın',
      registerTitle: 'Yeni Hesap Oluşturun',
      registerDescription: 'Ücretsiz hesap oluşturarak hemen başlayın',
      email: 'E-posta',
      password: 'Şifre',
      fullName: 'Ad Soyad',
      alreadyHaveAccount: 'Zaten hesabınız var mı?',
      noAccount: 'Hesabınız yok mu?',
      loginSuccess: 'Giriş başarılı!',
      registerSuccess: 'Kayıt başarılı! Hoş geldiniz.',
      or: 'veya',
      
      // Home
      heroTitle: 'Wellness Yolculuğunuza Başlayın',
      heroSubtitle: 'Pilates, Yoga, Meditasyon ve Nefes çalışmalarıyla sağlıklı ve dengeli bir yaşam için ihtiyacınız olan her şey burada. Uzman eğitmenlerden canlı veya kayıtlı derslere katılarak kendinize yatırım yapın.',
      getStarted: 'Dersleri Keşfet',
      trustBadge: 'Tüm ödemeler iyzico güvencesiyle güvenli şekilde işlenir.',
      featuredLessons: 'Öne Çıkan Dersler',
      featuredInstructors: 'Uzman Eğitmenlerle Tanışın',
      featuredInstructorsSubtitle: 'Deneyimli ve sertifikalı eğitmenlerle güvenle çalışın. Her eğitmenin özel ders tarzı ve programı ile tanışabilir, canlı derslerine katılabilirsiniz.',
      
      // How It Works
      howItWorks: 'Nasıl Çalışır?',
      step1Title: 'Kayıt Olun',
      step1Desc: 'Dakikalar içinde üye olun ve kişisel profilinizi oluşturun.',
      step2Title: 'Ders Seçin',
      step2Desc: 'Pilates, yoga, meditatif nefes, fitness ve daha birçok alanda uzman eğitmenlerle tanışın. Canlı veya kayıtlı ders seçenekleri arasından seçiminizi yapın.',
      step3Title: 'Katılın ve Gelişin',
      step3Desc: 'Derse tek dokunuşla katılın, AI destekli kişisel programınızla ilerlemenizi takip edin.',
      
      // Categories
      allCategories: 'Tüm Wellness Kategorileri',
      categoriesSubtitle: 'Hedeflerinize en uygun dersleri kolayca bulun ve programınıza ekleyin.',
      
      // Categories
      pilates: 'Pilates',
      yoga: 'Yoga',
      meditation: 'Meditasyon',
      fitness: 'Fitness',
      breathing: 'Nefes',
      posture: 'Postür',
      
      // Levels
      beginner: 'Başlangıç',
      intermediate: 'Orta',
      advanced: 'İleri',
      
      // Lesson Types
      live: 'Canlı Ders',
      recorded: 'Kayıtlı Ders',
      live_plus_recorded: 'Canlı + Kayıt',
      group: 'Grup',
      oneOnOne: 'Birebir',
      
      // Common
      price: 'Fiyat',
      duration: 'Süre',
      minutes: 'dakika',
      viewDetails: 'Detayları Gör',
      bookNow: 'Hemen Rezerve Et',
      all: 'Tümü',
      category: 'Kategori',
      level: 'Seviye',
      type: 'Tür',
      
      // AI Program
      aiProgramTitle: 'Kişisel AI Wellness Programınızı Oluşturun',
      aiProgramSubtitle: 'Yaşınıza, hedefinize ve günlük temponuza göre tamamen size özel 4 haftalık program hazırlıyoruz. Pilates, yoga ve nefes egzersizleri bir arada, tek bir plan içinde.',
      aiProgramNote: 'Program oluşturulduktan sonra haftalık ders planınızı görebilir, dilediğiniz derslere tek tıkla katılabilirsiniz.',
      age: 'Yaş',
      height: 'Boy (cm)',
      weight: 'Kilo (kg)',
      goal: 'Hedefiniz',
      weightLoss: 'Kilo Verme',
      flexibility: 'Esneklik',
      strength: 'Güçlenme',
      stressRelief: 'Stres Azaltma',
      postureCorrection: 'Duruş Düzeltme',
      daysPerWeek: 'Haftada Kaç Gün',
      generateProgram: 'Program Oluştur',
      startAIProgram: 'AI Programını Başlat',
      
      // Secure Payment
      securePayment: 'Güvenli Ödeme Altyapısı',
      securePaymentDesc: 'iyzico güvenceli ödeme sistemi ile kart bilgileriniz en yüksek güvenlik standartlarıyla işlenir. Ödemeler PCI-DSS uyumlu altyapıda korunur.',
      
      // FAQ
      faq: 'Sık Sorulan Sorular',
      faqQ1: 'Dersler canlı mı yoksa kayıtlı mı?',
      faqA1: 'Her iki seçenek de mevcut. Canlı derslere anlık katılabilir, kaçırdığınız dersleri kayıtlı olarak izleyebilirsiniz.',
      faqQ2: 'Eğitmenlere nasıl güvenebilirim?',
      faqA2: 'Tüm eğitmenler sertifikalarını yükleyerek onay sürecinden geçer.',
      faqQ3: 'Ödemeler güvenli mi?',
      faqA3: 'iyzico güvenceli altyapı ile tüm ödemeleriniz güvenli şekilde işlenir.',
      faqQ4: 'AI program gerçekten kişisel mi?',
      faqA4: 'Evet. AI motoru yaş, seviyeniz, hedefiniz ve zamanınıza göre size özel bir plan oluşturur.',
      
      // Footer
      about: 'Hakkımızda',
      becomeInstructor: 'Eğitmen Ol',
      contact: 'İletişim',
      kvkk: 'KVKK',
      terms: 'Kullanım Koşulları',
      privacy: 'Gizlilik Politikası',
      copyright: '© 2025 Pilatika. Tüm Hakları Saklıdır.',
      
      // Premium Page
      premiumTitle: 'Premium Üyelik ile Wellness Yolculuğunuza Hız Katın',
      premiumSubtitle: 'Tüm kayıtlı derslere sınırsız erişim, AI destekli kişisel program, özel eğitmen içerikleri ve çok daha fazlası… Sağlıklı yaşam için ihtiyacınız olan her şey tek bir üyelikte.',
      monthly: 'Aylık',
      yearly: 'Yıllık',
      monthlyPremium: 'Aylık Premium',
      yearlyPremium: 'Yıllık Premium',
      mostPopular: 'En Çok Tercih Edilen',
      perMonth: '/ ay',
      perYear: '/ yıl',
      monthlyEquivalent: 'Aylık 107 TL\'ye denk gelir',
      twoMonthsFree: '2 ay ücretsiz',
      startMembership: 'Üyeliği Başlat',
      selectYearlyPlan: 'Yıllık Planı Seç',
      freeStarter: 'Ücretsiz Üyelik (Starter)',
      startFree: 'Ücretsiz Başla',
      
      // Premium Features
      premiumFeatures: 'Premium Üyelik Avantajları',
      unlimitedAccess: 'Sınırsız Ders Erişimi',
      unlimitedAccessDesc: 'Tüm kayıtlı pilates, yoga, meditasyon ve nefes derslerine sınırsız erişim.',
      premiumAI: 'Premium AI Programı',
      premiumAIDesc: 'Tamamen kişisel 4 ve 8 haftalık wellness programları: hedefe göre özelleştirilmiş ders takvimi.',
      exclusiveContent: 'Eğitmen Özel İçerikleri',
      exclusiveContentDesc: 'Premium üyeler için eğitmenlerin hazırladığı ileri seviye dersler ve mikro programlar.',
      discountedLive: 'İndirimli Canlı Ders Fiyatları',
      discountedLiveDesc: 'Premium kullanıcılar tüm canlı derslerde %20 indirim kazanır.',
      weeklyAnalysis: 'İlerlemeni Haftalık Analiz Et',
      weeklyAnalysisDesc: 'AI, haftalık ilerlemenizi analiz ederek geri bildirim sunar.',
      earlyAccess: 'Erken Erişim Avantajı',
      earlyAccessDesc: 'Yeni yüklenen dersleri herkesten önce izleyin.',
      personalNotifications: 'Kişiye Özel Bildirimler',
      personalNotificationsDesc: 'Hedeflerinize göre günlük/haftalık hatırlatmalar.',
      
      // Comparison Table
      compareTitle: 'Ücretsiz vs Premium',
      feature: 'Özellik',
      free: 'Ücretsiz',
      premium: 'Premium',
      unlimitedRecorded: 'Sınırsız kayıtlı ders',
      premiumAIProgram: 'Premium AI Program',
      instructorExclusive: 'Eğitmen özel içerikleri',
      earlyAccessFeature: 'Derslere erken erişim',
      liveDiscount: 'Canlı derslerde indirim',
      progressAnalysis: 'Haftalık ilerleme analizi',
      customPrograms: 'Favori program oluşturma',
      
      // Security & Payment
      securePaymentTitle: 'Güven ve Ödeme Bilgileri',
      securePaymentInfo: 'Tüm ödemeler iyzico güvencesiyle alınır. Kart bilgileriniz PCI-DSS uyumlu altyapıda korunur.',
      autoRenewal: 'Otomatik Yenileme',
      autoRenewalDesc: 'Premium üyelikleriniz her dönem güvenli şekilde otomatik yenilenir. Dilediğiniz zaman tek dokunuşla iptal edebilirsiniz.',
      
      // Premium FAQ
      premiumFaqQ1: 'Premium üyeliği istediğim zaman iptal edebilir miyim?',
      premiumFaqA1: 'Evet. Üyeliğinizi istediğiniz an tek tuşla iptal edebilirsiniz. İptal sonrası dönem sonuna kadar premium avantajlar devam eder.',
      premiumFaqQ2: 'Canlı derslere erişim premium üyelikte ücretsiz mi?',
      premiumFaqA2: 'Canlı dersler ayrı ücretlidir ancak premium üyeler %20 indirim kazanır.',
      premiumFaqQ3: 'Premium AI programı ile temel AI programı arasındaki fark nedir?',
      premiumFaqA3: 'Premium AI programı haftalık ilerleme takibi, hedef optimizasyonu ve daha geniş ders kütüphanesi ile çalışır.',
      premiumFaqQ4: 'Yıllık üyelik avantajı nedir?',
      premiumFaqA4: 'Aylık aboneliğe göre 2 ay ücretsizdir ve bazı özel içeriklere erken erişim sağlar.',
      
      // Final CTA
      readyToStart: 'Hazır mısınız?',
      readyToStartDesc: 'Daha güçlü bir beden, daha sakin bir zihin ve daha dengeli bir yaşam burada başlıyor.',
      
      // Lesson Detail Page
      lessonOverview: 'Ders Hakkında',
      whatYouWillLearn: 'Neler Öğreneceksiniz',
      instructor: 'Eğitmen',
      lessonContent: 'Ders İçeriği',
      technicalDetails: 'Teknik Detaylar',
      duration: 'Süre',
      lessonType: 'Ders Tipi',
      equipment: 'Ekipman',
      language: 'Dil',
      cancelPolicy: 'İptal & İade',
      cancelPolicyRecorded: 'Kayıtlı ders: Satın alımdan 24 saat içinde iade yapılabilir.',
      cancelPolicyLive: 'Canlı ders: Ders başlangıcından 3 saat öncesine kadar iptal edilebilir.',
      recommendedLessons: 'Önerilen Dersler',
      usersAlsoBought: 'Kullanıcılar bunları da aldı',
      purchaseLesson: 'Dersi Satın Al',
      startLesson: 'Dersi Başlat',
      addToFavorites: 'Favorilere Ekle',
      joined: 'katılımcı',
      
      // Favorites
      myFavorites: 'Favori Derslerim',
      favoritesDesc: 'Sık izlediğiniz dersleri buradan hızlıca başlatabilirsiniz.',
      noFavorites: 'Henüz favori eklemediniz. Beğendiğiniz dersleri kalp ikonuyla kaydedin.',
      
      // Calendar
      liveCalendar: 'Canlı Ders Takvimi',
      upcomingLessons: 'Yaklaşan Dersler',
      noUpcomingLessons: 'Henüz planlanmış bir canlı dersiniz yok.',
      joinLesson: 'Derse Katıl',
      
      // Account Settings
      accountSettings: 'Hesap Ayarları',
      membership: 'Üyelik',
      membershipType: 'Üyelik Türü',
      manageMembership: 'Üyeliği Yönet',
      billingHistory: 'Fatura Geçmişi',
      purchasedLessons: 'Satın Alınan Dersler',
      notificationSettings: 'Bildirim Ayarları',
      lessonReminders: 'Ders Hatırlatmaları',
      programNotifications: 'Program Bildirimleri',
      security: 'Güvenlik',
      changePassword: 'Parola Değiştir',
      passwordRequirement: 'Yeni şifre en az 6 haneli olmalıdır.',
      deleteAccount: 'Hesabı Sil',
      deleteAccountWarning: 'Hesabınızı sildiğinizde tüm verileriniz kalıcı olarak silinir.',
      
      // AI Instructors
      aiInstructor: 'AI Eğitmen',
      humanInstructor: 'Gerçek Eğitmen',
      aiGenerated: 'AI Tarafından Oluşturuldu',
      aiGeneratedDesc: 'Bu ders yapay zeka eğitmeni tarafından kaydedilmiş içeriktir.',
      allInstructors: 'Tüm Eğitmenler',
      filterByType: 'Eğitmen Tipi',
      
      // Instructors Page
      expertInstructors: 'Uzman Eğitmen Kadromuz',
      expertInstructorsSubtitle: 'Her biri deneyimli ve sertifikalı eğitmenlerimiz ile hedeflerinize güvenle ulaşın.',
      viewProfile: 'Profilini Gör',
      viewLessons: 'Derslerini Gör',
      experiencedInstructor: 'alanda uzmanlaşmış, deneyimli eğitmen. Canlı ve kayıtlı ders seçenekleri bulunur.',
      
      // Instructor Profile
      certifiedInstructor: 'Sertifikalı Pilates & Postür Eğitmeni',
      yearsExperience: 'yıllık profesyonel deneyim',
      about: 'Hakkında',
      expertise: 'Uzmanlık Alanları',
      certificates: 'Sertifikalar ve Eğitimler',
      teachingApproach: 'Eğitmen Yaklaşımı',
      instructorLessons: 'Dersler',
      studentReviews: 'Öğrenci Yorumları',
      availability: 'Uygunluk Takvimi',
      sendMessage: 'Eğitmene Mesaj Gönderin',
      sendMessageDesc: 'Sorularınız veya özel ders talepleriniz için eğitmene kısa bir mesaj bırakabilirsiniz.',
      trustNote: 'Güven Notu',
      trustNoteDesc: 'Tüm eğitmenlerimiz kimlik ve sertifika doğrulamasından geçer. Platformumuzda yer alan her eğitmen, uzmanlık alanına uygun şekilde ders verme yetkinliğine sahiptir.',
      contactInstructor: 'Eğitmenle İletişime Geç',
      premiumPrograms: 'Premium Programları İncele',
      
      // Auth
      email: 'E-posta',
      password: 'Şifre',
      fullName: 'Ad Soyad',
      loginTitle: 'Giriş Yap',
      registerTitle: 'Kayıt Ol',
      loginSuccess: 'Giriş başarılı!',
      registerSuccess: 'Kayıt başarılı!',
      
      // Instructor
      becomeInstructor: 'Eğitmen Ol',
      instructorDashboard: 'Eğitmen Paneli',
      applyAsInstructor: 'Eğitmen Başvurusu',
      bio: 'Hakkımda',
      specialties: 'Uzmanlık Alanları',
      iban: 'IBAN',
      certificates: 'Sertifikalar',
      
      // Profile
      myBookings: 'Rezervasyonlarım',
      myPrograms: 'Programlarım',
      settings: 'Ayarlar',
      language: 'Dil',
    }
  },
  en: {
    translation: {
      // Navigation
      home: 'Home',
      lessons: 'Lessons',
      instructors: 'Instructors',
      aiProgram: 'AI Program',
      myProfile: 'My Profile',
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      
      // Home
      heroTitle: 'Start Your Wellness Journey',
      heroSubtitle: 'Everything you need for a healthy and balanced life with Pilates, Yoga, Meditation and Breathing exercises. Invest in yourself by joining live or recorded classes from expert instructors.',
      getStarted: 'Explore Lessons',
      trustBadge: 'All payments are processed securely with iyzico guarantee.',
      featuredLessons: 'Featured Lessons',
      featuredInstructors: 'Meet Our Expert Instructors',
      featuredInstructorsSubtitle: 'Work confidently with experienced and certified instructors. Discover each instructor\'s unique teaching style and program, join their live classes.',
      
      // How It Works
      howItWorks: 'How It Works?',
      step1Title: 'Sign Up',
      step1Desc: 'Become a member in minutes and create your personal profile.',
      step2Title: 'Choose a Lesson',
      step2Desc: 'Meet expert instructors in pilates, yoga, meditative breathing, fitness and many more areas. Choose from live or recorded lesson options.',
      step3Title: 'Join and Improve',
      step3Desc: 'Join the class with a single touch, track your progress with your AI-powered personal program.',
      
      // Categories
      allCategories: 'All Wellness Categories',
      categoriesSubtitle: 'Easily find lessons that suit your goals and add them to your program.',
      
      // Categories
      pilates: 'Pilates',
      yoga: 'Yoga',
      meditation: 'Meditation',
      fitness: 'Fitness',
      breathing: 'Breathing',
      posture: 'Posture',
      
      // Levels
      beginner: 'Beginner',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
      
      // Lesson Types
      live: 'Live Class',
      recorded: 'Recorded',
      live_plus_recorded: 'Live + Recording',
      group: 'Group',
      oneOnOne: 'One-on-One',
      
      // Common
      price: 'Price',
      duration: 'Duration',
      minutes: 'minutes',
      viewDetails: 'View Details',
      bookNow: 'Book Now',
      
      // AI Program
      aiProgramTitle: 'Create Your Personal AI Wellness Program',
      aiProgramSubtitle: 'We prepare a completely personalized 4-week program based on your age, goal and daily tempo. Pilates, yoga and breathing exercises together in a single plan.',
      aiProgramNote: 'After your program is created, you can view your weekly lesson plan and join any lesson with a single click.',
      age: 'Age',
      height: 'Height (cm)',
      weight: 'Weight (kg)',
      goal: 'Your Goal',
      weightLoss: 'Weight Loss',
      flexibility: 'Flexibility',
      strength: 'Strength',
      stressRelief: 'Stress Relief',
      postureCorrection: 'Posture Correction',
      daysPerWeek: 'Days Per Week',
      generateProgram: 'Generate Program',
      startAIProgram: 'Start AI Program',
      
      // Secure Payment
      securePayment: 'Secure Payment Infrastructure',
      securePaymentDesc: 'Your card information is processed with the highest security standards with iyzico secure payment system. Payments are protected in PCI-DSS compliant infrastructure.',
      
      // FAQ
      faq: 'Frequently Asked Questions',
      faqQ1: 'Are lessons live or recorded?',
      faqA1: 'Both options are available. You can join live classes instantly or watch missed classes as recordings.',
      faqQ2: 'How can I trust the instructors?',
      faqA2: 'All instructors go through an approval process by uploading their certificates.',
      faqQ3: 'Are payments secure?',
      faqA3: 'All your payments are processed securely with iyzico secure infrastructure.',
      faqQ4: 'Is the AI program really personal?',
      faqA4: 'Yes. The AI engine creates a special plan for you based on your age, level, goal and time.',
      
      // Footer
      about: 'About Us',
      becomeInstructor: 'Become Instructor',
      contact: 'Contact',
      kvkk: 'Privacy Policy',
      terms: 'Terms of Use',
      privacy: 'Privacy Policy',
      copyright: '© 2025 Pilatika. All Rights Reserved.',
      
      // Premium Page
      premiumTitle: 'Accelerate Your Wellness Journey with Premium Membership',
      premiumSubtitle: 'Unlimited access to all recorded classes, AI-powered personal programs, exclusive instructor content and much more... Everything you need for a healthy life in one membership.',
      monthly: 'Monthly',
      yearly: 'Yearly',
      monthlyPremium: 'Monthly Premium',
      yearlyPremium: 'Yearly Premium',
      mostPopular: 'Most Popular',
      perMonth: '/ month',
      perYear: '/ year',
      monthlyEquivalent: 'Equivalent to $9/month',
      twoMonthsFree: '2 months free',
      startMembership: 'Start Membership',
      selectYearlyPlan: 'Select Yearly Plan',
      freeStarter: 'Free Membership (Starter)',
      startFree: 'Start Free',
      
      // Premium Features
      premiumFeatures: 'Premium Membership Benefits',
      unlimitedAccess: 'Unlimited Class Access',
      unlimitedAccessDesc: 'Unlimited access to all recorded pilates, yoga, meditation and breathing classes.',
      premiumAI: 'Premium AI Program',
      premiumAIDesc: 'Completely personalized 4 and 8-week wellness programs: customized lesson calendar according to your goal.',
      exclusiveContent: 'Instructor Exclusive Content',
      exclusiveContentDesc: 'Advanced classes and micro programs prepared by instructors for premium members.',
      discountedLive: 'Discounted Live Class Prices',
      discountedLiveDesc: 'Premium users get 20% discount on all live classes.',
      weeklyAnalysis: 'Weekly Progress Analysis',
      weeklyAnalysisDesc: 'AI analyzes your weekly progress and provides feedback.',
      earlyAccess: 'Early Access Advantage',
      earlyAccessDesc: 'Watch newly uploaded classes before everyone else.',
      personalNotifications: 'Personalized Notifications',
      personalNotificationsDesc: 'Daily/weekly reminders based on your goals.',
      
      // Comparison Table
      compareTitle: 'Free vs Premium',
      feature: 'Feature',
      free: 'Free',
      premium: 'Premium',
      unlimitedRecorded: 'Unlimited recorded classes',
      premiumAIProgram: 'Premium AI Program',
      instructorExclusive: 'Instructor exclusive content',
      earlyAccessFeature: 'Early access to classes',
      liveDiscount: 'Live class discount',
      progressAnalysis: 'Weekly progress analysis',
      customPrograms: 'Custom program creation',
      
      // Security & Payment
      securePaymentTitle: 'Trust and Payment Information',
      securePaymentInfo: 'All payments are received with iyzico guarantee. Your card information is protected in PCI-DSS compliant infrastructure.',
      autoRenewal: 'Auto Renewal',
      autoRenewalDesc: 'Your premium memberships are automatically renewed safely every period. You can cancel with one touch at any time.',
      
      // Premium FAQ
      premiumFaqQ1: 'Can I cancel my premium membership at any time?',
      premiumFaqA1: 'Yes. You can cancel your membership at any time with one button. Premium benefits continue until the end of the period after cancellation.',
      premiumFaqQ2: 'Is access to live classes free with premium membership?',
      premiumFaqA2: 'Live classes are separately charged but premium members get 20% discount.',
      premiumFaqQ3: 'What is the difference between premium AI program and basic AI program?',
      premiumFaqA3: 'Premium AI program works with weekly progress tracking, goal optimization and a wider lesson library.',
      premiumFaqQ4: 'What is the advantage of yearly membership?',
      premiumFaqA4: 'It is 2 months free compared to monthly subscription and provides early access to some exclusive content.',
      
      // Final CTA
      readyToStart: 'Ready to Start?',
      readyToStartDesc: 'A stronger body, a calmer mind and a more balanced life starts here.',
      
      // Lesson Detail Page
      lessonOverview: 'About This Lesson',
      whatYouWillLearn: 'What You Will Learn',
      instructor: 'Instructor',
      lessonContent: 'Lesson Content',
      technicalDetails: 'Technical Details',
      duration: 'Duration',
      lessonType: 'Lesson Type',
      equipment: 'Equipment',
      language: 'Language',
      cancelPolicy: 'Cancellation & Refund',
      cancelPolicyRecorded: 'Recorded lesson: Refund available within 24 hours of purchase.',
      cancelPolicyLive: 'Live lesson: Can be cancelled up to 3 hours before lesson start.',
      recommendedLessons: 'Recommended Lessons',
      usersAlsoBought: 'Users also bought these',
      purchaseLesson: 'Purchase Lesson',
      startLesson: 'Start Lesson',
      addToFavorites: 'Add to Favorites',
      joined: 'participants',
      
      // Favorites
      myFavorites: 'My Favorite Lessons',
      favoritesDesc: 'You can quickly start your frequently watched lessons from here.',
      noFavorites: 'You haven\'t added any favorites yet. Save lessons you like with the heart icon.',
      
      // Calendar
      liveCalendar: 'Live Lesson Calendar',
      upcomingLessons: 'Upcoming Lessons',
      noUpcomingLessons: 'You don\'t have any scheduled live lessons yet.',
      joinLesson: 'Join Lesson',
      
      // Account Settings
      accountSettings: 'Account Settings',
      membership: 'Membership',
      membershipType: 'Membership Type',
      manageMembership: 'Manage Membership',
      billingHistory: 'Billing History',
      purchasedLessons: 'Purchased Lessons',
      notificationSettings: 'Notification Settings',
      lessonReminders: 'Lesson Reminders',
      programNotifications: 'Program Notifications',
      security: 'Security',
      changePassword: 'Change Password',
      passwordRequirement: 'New password must be at least 6 characters.',
      deleteAccount: 'Delete Account',
      deleteAccountWarning: 'When you delete your account, all your data will be permanently deleted.',
      
      // AI Instructors
      aiInstructor: 'AI Instructor',
      humanInstructor: 'Human Instructor',
      aiGenerated: 'AI Generated',
      aiGeneratedDesc: 'This lesson is recorded content by an AI instructor.',
      allInstructors: 'All Instructors',
      filterByType: 'Instructor Type',
      
      // Instructors Page
      expertInstructors: 'Our Expert Instructors',
      expertInstructorsSubtitle: 'Reach your goals confidently with our experienced and certified instructors.',
      viewProfile: 'View Profile',
      viewLessons: 'View Lessons',
      experiencedInstructor: 'specialized, experienced instructor. Live and recorded lesson options available.',
      
      // Instructor Profile
      certifiedInstructor: 'Certified Pilates & Posture Instructor',
      yearsExperience: 'years of professional experience',
      about: 'About',
      expertise: 'Expertise',
      certificates: 'Certificates and Training',
      teachingApproach: 'Teaching Approach',
      instructorLessons: 'Lessons',
      studentReviews: 'Student Reviews',
      availability: 'Availability Calendar',
      sendMessage: 'Send Message to Instructor',
      sendMessageDesc: 'You can leave a short message to the instructor for your questions or private lesson requests.',
      trustNote: 'Trust Note',
      trustNoteDesc: 'All our instructors pass identity and certificate verification. Every instructor on our platform is qualified to teach in their area of expertise.',
      contactInstructor: 'Contact Instructor',
      premiumPrograms: 'View Premium Programs',
      
      // Auth
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      loginTitle: 'Login',
      registerTitle: 'Register',
      loginSuccess: 'Login successful!',
      registerSuccess: 'Registration successful!',
      
      // Instructor
      becomeInstructor: 'Become Instructor',
      instructorDashboard: 'Instructor Dashboard',
      applyAsInstructor: 'Apply as Instructor',
      bio: 'Bio',
      specialties: 'Specialties',
      iban: 'IBAN',
      certificates: 'Certificates',
      
      // Profile
      myBookings: 'My Bookings',
      myPrograms: 'My Programs',
      settings: 'Settings',
      language: 'Language',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;